import React, { useEffect } from 'react';

import useGlobal from '../../../store';
import { Auth } from '../../../support';
import { FormControl } from '../../../facturotopia';
import LoadingButton from '../../../facturotopia/LoadingButton';
import { TheResult, TheError } from '../../../shared/responses/TheResult';

const options = [
  {
    label: 'Mi cuenta',
    value: 'cliente',
  },
  {
    label: 'Empresas',
    value: 'empresa',
  },
];

const mapState = (store) => {
  return {
    hits: store.cuenta.hits.balance,
  };
};

const mapActions = (actions) => {
  return { hits: actions.cuenta.hits.balance };
};

const ConfiguracionHitsBalance = (props) => {
  const [state, actions] = useGlobal(mapState, mapActions);
  const { busy, data, result, error } = state.hits;

  useEffect(() => {
    const data = Auth.getData();
    const { cliente } = data;

    actions.hits.change({
      hits_balance: cliente.hits_balance || 'empresa',
    });

    return () => {
      actions.hits.reset();
    };
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (!!result) {
      const original = Auth.getData();
      const { cliente } = original;

      const data = {
        ...original,
        cliente: {
          ...cliente,
          ...result.data,
        },
      };

      Auth.setData(data);

      if (!!props.onConfigUpdateSuccess) {
        props.onConfigUpdateSuccess(result.data);
      }
    }
  }, [result]); // eslint-disable-line react-hooks/exhaustive-deps

  const handleOnChange = (value) => {
    actions.hits.change({
      data: { hits_balance: value.hits_balance || 'empresa' },
    });
  };

  const handleOnSubmit = () => {
    actions.hits.submit();
  };

  return (
    <div>
      <div className="row">
        <div className="col-sm-5">
          <FormControl
            type="select"
            label="Asignar hits a:"
            name="hits_balance"
            placeholder=""
            help=""
            value={data.hits_balance}
            options={options}
            onChange={handleOnChange}
          />
        </div>
      </div>

      {!!result && <TheResult result={result} />}

      {!!error && <TheError error={error} />}

      <div className="row">
        <div className="col">
          <LoadingButton
            type="button"
            disabled={busy}
            loading={busy || false}
            onClick={handleOnSubmit}
          >
            {busy ? 'Guardando...' : 'Guardar'}
          </LoadingButton>
        </div>
      </div>
    </div>
  );
};

export default ConfiguracionHitsBalance;
